export default "__VITE_ASSET__B7eAUu5x__"